function AriaLabel() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>An aria-label or aria-labelledby attribute is present.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>ARIA labels define accessible names to be read by screen readers for interface elements. They may be used when HTML associations (label, alternative text, etc.) are not sufficient.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Ensure the aria-label value or element referenced by aria-labelledby provides a descriptive, accurate label. When possible, use standard HTML <code>&lt;label&gt;</code> or other markup to make the association.</p>
    </blockquote>
  )
}

export default AriaLabel